(() => {
  const initialize = (root) => {
    if (!root || root.dataset.mmScrewReady === "true") return;
    root.dataset.mmScrewReady = "true";

    const variants = JSON.parse(root.querySelector("[data-mm-screw-variants]")?.textContent || "[]");
    const groups = [...root.querySelectorAll("[data-mm-screw-option-group]")];
    const idInput = root.querySelector("[data-mm-screw-variant]");
    const image = root.querySelector("[data-mm-screw-image]");
    const model = root.querySelector("[data-mm-screw-model]");
    const price = root.querySelector("[data-mm-screw-price]");
    const sku = root.querySelector("[data-mm-screw-sku]");
    const selection = root.querySelector("[data-mm-screw-selection]");
    const state = root.querySelector("[data-mm-screw-state]");
    const submit = root.querySelector("[data-mm-screw-submit]");
    const submitLabel = root.querySelector("[data-mm-screw-submit-label]");
    const locale = document.documentElement.lang || "en";
    const currency = window.Shopify?.currency?.active || "USD";
    const money = (cents) => new Intl.NumberFormat(locale, { style: "currency", currency }).format(Number(cents || 0) / 100);

    const selectedOptions = () => groups
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((group) => group.querySelector("[data-mm-screw-option]:checked")?.value || "");

    const sync = () => {
      const options = selectedOptions();
      const variant = variants.find((candidate) => candidate.options.every((value, index) => value === options[index]));
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (sku) sku.textContent = variant.sku || "Assigned at release";
      if (selection) selection.textContent = options.join(" / ");

      const available = Boolean(variant.available);
      if (state) state.textContent = available ? "READY TO ORDER" : "DRAFT / PRICING PENDING";
      if (submit) submit.disabled = !available;
      if (submitLabel) submitLabel.textContent = available ? "ADD MOUNTING SET TO CART" : "CURRENTLY UNAVAILABLE";

      const imageUrl = variant.featured_image?.src || variant.featured_image?.url;
      if (image && imageUrl) {
        image.removeAttribute("srcset");
        image.src = imageUrl;
        image.alt = `EXO-HDW Multi-Material Screw ${options.join(" / ")}`;
      }
      if (model) model.textContent = options[0];

      const target = new URL(window.location.href);
      target.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", `${target.pathname}${target.search}${target.hash}`);
    };

    root.querySelectorAll("[data-mm-screw-option]").forEach((input) => input.addEventListener("change", sync));
    sync();
  };

  const initializeAll = (scope = document) => scope.querySelectorAll("[data-mm-screw-product]").forEach(initialize);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initializeAll());
  else initializeAll();
  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
